import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from "redux";
import { useHistory } from "react-router-dom";

import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { TextField, Dropdown, Selection, Orientation, Card, Checkbox, ComboBox } from 'ktr-materialui-react';

import { InputElement, InputSingleValueString, InputSingleValueNumber, InputOptional, InputPageForward, InputValueBoolean, InputAction, InputType, InputImage, InputLabel, InputTable, InputPdf, InputUpload, UIElementHint } from '../../service/flowengine/model/Element';
import { Flow, getFlow, getPageByKey, getPageByIndex, getNextPageKey, getPrevPageKey, getElementWithPagename, testPageMandatoryByName } from '../../service/flowengine/FlowEngineAPI';
import { Page } from "../../service/flowengine/model/Page"

import UploadFilesDragAndDrop from "../UploadFilesDragAndDrop/UploadFilesDragAndDrop"

import { RootState } from '../../store/Store';
import { FlowState, updateFlowInputAction } from '../../store/reducers/FlowReducer'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import HomeIcon from '@material-ui/icons/Home';
import Snackbar from '@material-ui/core/Snackbar';
//import IconButton from '@material-ui/core/IconButton';
//import CloseIcon from '@material-ui/icons/Close';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';

//import { createPDFGeneric } from '../../service/pdf/PDFCreator'
import { Document, Page as PdfPage, pdfjs } from 'react-pdf'


import { useTranslation } from 'react-i18next';


// ---
// Local Alert component
function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------

type Props = {
  //key?: number;
  pagename?: string;
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    flow: Flow
}

type PropsHandler = {
    updateFlowInput(state: FlowState): any,
}


// --------------------------------------------------
// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    flow: state.flow.flow,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateFlowInput: (state: FlowState) => dispatch(updateFlowInputAction(state)),
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type GenericPageComponentProps = Props & PropsStatic & PropsHandler;


// ---------------------------------------------------
var pageToDisplay: Page;

// ---------------------------------------------------
// ---------------------------------------------------
// Component
// ---------------------------------------------------
const GenericPageComponent : React.FunctionComponent<GenericPageComponentProps> = (props) => {
  // state as hook
  //const [invalid, setInvalid] = useState<Boolean>(false);                // JavaScript "array destructuring": [term1, term2, term3] is translated into 3 single variables "term1", "term2" and "term3"

  let history = useHistory();
  //const [jsonstring, setJsonstring] = useState<string>("");                // JavaScript "array destructuring": [term1, term2, term3] is translated into 3 single variables "term1", "term2" and "term3"

  const [openSnackbar, setOpenSnackbar] = React.useState<boolean>(false);                                    // is Snackbar visible !
  const [messageSnackbar, setMessageSnackbar] = React.useState<string>("Fehler, ev. fehlende Eingaben ?");   // Message of Snackbar


  const { t, i18n } = useTranslation();


  // ------------
  function inputChangedSelectBox(el: InputOptional, id: string) {

//value ist jetzt index

//    el.value = id; 

    // update store
    var eventIdx: number = -1;
    if(el !== undefined) {
      let idx: number = 0;
      // eslint-disable-next-line array-callback-return
      el.options.map( (o: string) => {
          if(o === id) eventIdx = idx;
          idx++;
        }
      )
      //el.value = eventValue;
      el.value = eventIdx;
      
      // if the element has an "onAction" function-member: perform it:
      if(el.onAction !== undefined)
        el.onAction();

      // update flow in redux store:
      updateFlowRedux(getFlow() );
    }
  }

  // ------------
  function inputChangedSelectCard(el: InputElement, o: { idx: number,  value: string, text:string }) {
    //el.value = o.getValue(); 
    el.value = o.idx; 
      
    // update store
    if(el !== undefined) {
      // if the element has an "onAction" function-member: perform it:
      if(el.onAction !== undefined)
        el.onAction();

      // update flow in redux store:
      updateFlowRedux(getFlow() );

      gotoNextPage();
    }
  }

  // ------------
  function inputChangedComboBox(event: React.ChangeEvent<HTMLInputElement>, el: InputElement, value: {idx: number, value: string, text: string} ) {
    if((value === undefined) || (value === null))
      return;

    //el.value = value.value;   // update element in flow
    el.value = value.idx;   // update element in flow
    
    event.target.value = value.value;  // update actual combobox

    // update store
    if(el !== undefined) {
      // if the element has an "onAction" function-member: perform it:
      if(el.onAction !== undefined)
        el.onAction();

      // update flow in redux store:
      updateFlowRedux(getFlow() );
    }

  }

  // ------------
  function inputChangedDropDown(event: React.ChangeEvent<HTMLInputElement>) {
    var eventName: string = event.target.name;
    var eventValue: any = event.target.value;

    eventValue = event.target.value;

    // update matching value in Page:
    let el: InputOptional | undefined = getElementWithPagename(pageToDisplay.name, eventName) as InputOptional;

    // update store
    var eventIdx: number = -1;
    if(el !== undefined) {
      // --
      let idx: number = 0;
      // eslint-disable-next-line array-callback-return
      el.options.map( (o: string) => {
          if(o === eventValue) eventIdx = idx;
          idx++;
        }
      )
      //el.value = eventValue;
      el.value = eventIdx;

      // if the element has an "onAction" function-member: perform it:
      if(el.onAction !== undefined)
        el.onAction();

      // update flow in redux store:
      updateFlowRedux(getFlow() );
    }
  }

  // ------------
  function inputChanged(event: React.ChangeEvent<HTMLInputElement>) {
    var eventName: string = event.target.name;
    var eventValue: any = event.target.value;

    // dispatch action to update redux-state:
    //if((eventValue === "false") || (eventValue === "true")) {
    if(event.target.type === "checkbox") {
      eventValue = event.target.checked;
    }
    else 
    {
      eventValue = event.target.value;
    }

    // update matching value in Page:
    let el: InputElement | undefined = getElementWithPagename(pageToDisplay.name, eventName);

    // update store
    if(el !== undefined) {
      // --
      // update JSON output
      el.value = eventValue;

      // if the element has an "onAction" function-member: perform it:
      if(el.onAction !== undefined)
        el.onAction();

      // update flow in redux store:
      updateFlowRedux(getFlow() );
    }
  }

  // handle button in snackbar:
  const handleCloseSnackbar = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    // close snackbar
    setOpenSnackbar(false);
  };

  // -----------
  // flow structure is updated, trigger reducer: update local flow structure as a whole in store
  function updateFlowRedux(flow: Flow) {
    // DEBUG: serialize JSON of flow structure into textarea
    //setJsonstring(JSON.stringify(flow, undefined, 2));

    const state: FlowState = {
      //flow: { ...props.flow, flow}
      flow: flow
    }

    //const state: any = {
    //  flow: flow,
    //}
    props.updateFlowInput(state);
  }

  // -----------
  function handleSubmit (event: React.MouseEvent<HTMLElement>) {
    gotoNextPage();
  }

  // -----------
  function handleSubmitBack (event: React.MouseEvent<HTMLElement>) {
    gotoPrevPage();
  }

  // -----------
  function handleSubmitHome (event: React.MouseEvent<HTMLElement>) {
    let p: Page | undefined = getPageByIndex(0);

    if(p === undefined) return;
    history.push('./' + p.id);
  }

  // -----------
  // Jump to previous page:
  function gotoPrevPage () {
    // retrieve previous page (no validity check needed):
    let privpage: string = getPrevPageKey(pageToDisplay);
    // gotoprevious page (this is the name of the page which is used in router, i.e. "page1" is routed by "www.host.com/page1", etc.)
    history.push('./' + privpage);
  }

  // -----------
  function showMessageInSnackbar(msg: string) {
      // 
      setMessageSnackbar(msg);
      setOpenSnackbar(true);
  }

  // -----------
  // Jump to next page with respect to page content and nextResolver:
  function gotoNextPage () {
    // test if page is valid, i.e. if we are allowed to go to the next page
    //if(testPageMandatoryByName(pageToDisplay.name) === false) {   // all mandatory fields filled ?
    let validity = testPageMandatoryByName(pageToDisplay.name);   // all mandatory fields filled ?
    if(validity.res === false) {
      // page not valid (either mandatory fields are missing or some page-specific conditions in pages isValid-method are not matched)
      //showMessageInSnackbar("Unable to continue, page not valid: mandatory fields are missing.");
      showMessageInSnackbar("Eine verpflichtende Eingabe fehlt in Eingabefeld [" + validity.elname + "]");      
      return;
    }

    // if all mandatory fields are filled, test for page-specific validations by calling the isValid-function of page (if available)
    if(pageToDisplay.isValid !== undefined) {    // if page has an validator: call it
      if(pageToDisplay.isValid().res === false) {
        //showMessageInSnackbar("Unable to continue, internal page condition not met.");
        showMessageInSnackbar("Eingaben nicht valide. Bitte Eingaben überprüfen !");
        return false;
      }
    }

    // retrieve next page depending on input:
    //let nextpage: string = pageToDisplay.nextResolver();
    let nextpage: string = getNextPageKey(pageToDisplay);
    // goto next page (this is the name of the page which is used in router, i.e. "page1" is routed by "www.host.com/page1", etc.)
    history.push('./' + nextpage);
  }
  
  // --------------------------------------------------------------------------
  // Start displaying the page:
  if(props.pagename === undefined) {
    let p: Page | undefined = getPageByIndex(0);
    if(p !== undefined)
      pageToDisplay = p;
  }
  else {
    pageToDisplay = getPageByKey(props.pagename) as Page;
  }


  // ---------
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  // ---------
  pageToDisplay.onPageLoad();   // initialize page


  console.log("REDRAW Page");

  // ---------
  // iterate elements of page and display them
  let elementcounter: number = 0;
  let elements: InputElement[] = pageToDisplay.elements;
  let listInputJSXElement = new Array<JSX.Element>();
  elements.map(element => {
    // test if element is visible
    let el1: InputElement = element as InputElement;
    if(el1.isVisible !== undefined) {
      if (el1.isVisible() === false) return (listInputJSXElement);
      //if((element as InputElement).isVisible() === false) return (listInputJSXElement);
    }

    // display generic element
    switch(element.type) {
      case(InputType.ValueString): 
      {
        let el: InputSingleValueString = element as InputSingleValueString;
        //if(el.isVisible() === false) return (listInputJSXElement);
        let val: string = el.value as string;
        listInputJSXElement.push(
          <TextField
            key={elementcounter++}
            name= {el.name}
            type= "string"
            error= {false}
            errorText= "Wrong Input"
            value= {val}
            onChange= {(e) => inputChanged(e)}
            labelBefore= {el.label + (el.isMandatory === true ? ' *' : '')}
            labelAfter= {el.unit}
            placeholder= {el.label + " ..."}
          />
        )
      }
      break;

      case(InputType.ValueNumber): 
      {
        let el: InputSingleValueNumber = element as InputSingleValueNumber;
        let val: number = el.value as number;
        if((el.isValid !== undefined) && (el.isValid() === false)) val = 0; // new value is not valid
        listInputJSXElement.push(
          <TextField
            key={elementcounter++}
            name= {el.name}
            type= "number"
            error= {false}
            errorText= "Wrong Input"
            value= {val}
            onChange= {(e) => inputChanged(e)}
            labelBefore= {el.label + (el.isMandatory === true ? ' *' : '')}
            labelAfter= {el.unit}
          />
        )
      }
      break;

      case(InputType.Optional):
      {
        let el: InputOptional = element as InputOptional;
        //if(el.isVisible() === false) return (listInputJSXElement);
        //let val: string = el.value as string;
        let val: string = el.getValue() as string;     // e.value is index of options array as number, so we use getValue which returns the options entry itself
        let items: {idx: number, value: string, text:string}[] = [];
        let idx: number = 0;
        el.options.forEach( (o) => {
          items.push( { idx: idx++, value: o, text: o } );
        })

        if(el.uiElementHint === UIElementHint.Selectbox) {
          listInputJSXElement.push(
            <div key={elementcounter++} style={{padding: "10px"}}>
              <Selection
                key={elementcounter++}
                title={el.label + (el.isMandatory === true ? ' *' : '')}
                menuItems={items}
                getOptionLabel={(val: any) => { return (val.text + " "  + el.unit) }}
                getOptionValue={(val: any) => { return val.value }}
                //next line is disabled because the check if true or false is only working with == and not with ===
                //eslint-disable-next-line
                elementIsChecked={(val: any) => { return val.text === el.getValue() }}
                onChange={(id: string) => { inputChangedSelectBox(el, id) }}
                orientation={Orientation.Horizontal}
              />
            </div>
          )
        }
        else if(el.uiElementHint === UIElementHint.SelectCard) {
          // Insert Card element for each option, on click each card sets the value-attribute of the optional element and forwards accordingly
          <div>
            {el.label}<br/>
            {
              items.forEach( (o) => {
                listInputJSXElement.push(
                  <Card 
                    key={elementcounter++}
                    style={{width: "400px", display: "inline-block", margin:"5px"}} heading={o.value}
                    content={t("SelectionOf") + o.text}
                    buttonText={t("SelectNext")}
                    //imageURL={"./images/" + o.value.toLowerCase().replace(/ /g,'') + ".jpg"}   // in future: convention-over-configuration: place an image with name === el.name into public/images directory !!!
                    imageURL={"./images/" + el.assets[o.idx] + ".jpg"}
                    onClick={(e) => { inputChangedSelectCard(el, o) } }
                  />
                )
              })
            }  
          </div>            
        }
        else if(el.uiElementHint === UIElementHint.Combobox) {
          let items: any[] = [];
          if(el.options !== undefined) {
            let idx: number = 0;
            el.options.forEach( (o) => {
              items.push( { idx: idx++, value: o, text: o } );
            })
          }
          listInputJSXElement.push(
            <div key={elementcounter++}>
              <ComboBox
                key={elementcounter++}
                labelBefore= {el.label + (el.isMandatory === true ? ' *' : '')}
                onChange={(event, value) => { inputChangedComboBox(event, el, value) }}
                getOptionLabel= {(l:any) => (l.text + " " + el.unit) }
                options= {items}
                value= {{value: val, text: val}}   // is done in inputChangedComboBox !!!
                />
            </div>
          )
        } 
        else {   // DropDown
          listInputJSXElement.push(
            <Dropdown
              key={elementcounter++}
              id={"id" + el.name}
              select
              label= {el.label + (el.isMandatory === true ? ' *' : '')}
              value= {val}
              onChange={inputChangedDropDown}
              helperText=""
              getOptionLabel= {(l:any) => l.text }
              getOptionValue= {(l:any) => l.value }
              name= {el.name}
              items= {items}
            />
          )
        }
      }
      break;

      case(InputType.PageForward):
      {
        let el: InputPageForward = element as InputPageForward;
        // if(el.isVisible() === false) return (listInputJSXElement);
        let target: string = el.target as string;
        let val: string = el.value as string;

        if(el.uiElementHint === UIElementHint.Button) {
          listInputJSXElement.push(
            <Button
              key={elementcounter++}
              variant="outlined" 
              color="primary"               
              onClick={ handleSubmit }
              style={{"minWidth":"50px", "width": "100px", color: "white", margin: "2px"}}
            >
              {el.label}
            </Button>
          )
        } else {
          listInputJSXElement.push(
            <Card 
              key={elementcounter++}
              style={{width: "400px", display: "inline-block", margin:"5px"}} heading={el.label}
              content={el.content}
              buttonText={t("SelectNext")}
              //imageURL="https://www.ktr.com/fileadmin/ktr/media/ktr-extension/types/ElastischeKlauenBolzen_preview.jpg"
              imageURL="./images/ElastischeKlauenBolzen_preview.jpg"   // in future: convention-over-configuration: place an image with name === el.name into public/images directory !!!
              onClick={(e) => { el.value = val; history.push('./' + target) } }
            />
          )
        }
      }
      break;

      case(InputType.ValueBoolean):
        let el: InputValueBoolean = element as InputValueBoolean;
        //if(el.isVisible() === false) return (listInputJSXElement);
        let val: boolean = el.value as boolean;
        listInputJSXElement.push(
          <div key={elementcounter++} style={{padding: "10px", display: "inline-block"}}>
            <Checkbox 
              key={elementcounter++}
              id= {el.name}
              checked={val || false}
              onChange= {(e) => inputChanged(e)}
              name= {el.name}
              label= {el.label + (el.isMandatory === true ? ' *' : '')}
              labelPlacement="end"
            />
          </div>
        )
      break;

      case(InputType.Action): 
      {
        let el: InputAction = element as InputAction;
        //if(el.isVisible() === false) return (listInputJSXElement);
        //let val: string = el.value as string;
        listInputJSXElement.push(
            <Button 
              key={elementcounter++}
              variant="outlined" 
              color="primary" 
              style={{"minWidth":"200px", "width": "100px", color: "white", float: "right", margin: "10px"}} 
              onClick={ (e) => el.onAction() }
            >
              {el.label}
            </Button>
       )
      }
      break;

      case(InputType.Image): 
      {
        let el: InputImage = element as InputImage;
        //if(el.isVisible() === false) return (listInputJSXElement);
        //let val: string = el.value as string;
        listInputJSXElement.push(
          <div key={elementcounter++} style={{padding: "10px"}}>
            <img src={process.env.PUBLIC_URL + '/images/' + el.target.replace(/ /g,'') + '.jpg'} alt={el.label} />
          </div>
       )
      }
      break;

      case(InputType.Label): 
      {
        let el: InputLabel = element as InputLabel;
        let w: string = el.lwidth > 100 ? "40%" : (el.lwidth + "%");
        listInputJSXElement.push(
          <div key={elementcounter++} style={{padding: "5px", width: "100%"}}>
            <span style={{padding: "3px", display: "inline-block", width: w}}>
              {el.label}
            </span>
            <span style={{padding: "3px", border: "1px solid #F29401"}}>
              {el.value}
            </span>
            <span style={{padding: "3px", display: "inline-block"}}>
              &nbsp;{el.label_postfix}
            </span>

          </div>
       )
      }
      break;

      case(InputType.Table): 
      {
        let el: InputTable = element as InputTable;
        listInputJSXElement.push(
          <div key={elementcounter++}>
            <br/>
            <span>{el.label}</span>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    {el.header.map((h) => (
                      <TableCell key={elementcounter++}>{h}</TableCell>
                    ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                  {el.rows.map((row) => (
                    <TableRow key={elementcounter++}>
                      {row.map((cell) => (
                        <TableCell key={elementcounter++} component="th" scope="row">
                          {cell}
                        </TableCell>
                      ))}
                      </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )
      }
      break;

      case(InputType.Upload): 
      {
        let el: InputUpload = element as InputUpload;
        listInputJSXElement.push(
          <UploadFilesDragAndDrop header={el.label} />
        )
      }
      break;

      /*
      case(InputType.Pdf): 
      {
        let el: InputPdf = element as InputPdf;
        console.log("Rendering PDF ... (" + ((el.data !== undefined && el.data.length > 0) ? el.data.length : "0") + " bytes)");

        console.log("Rendering PDF ... --> 1");
        let promisePdfBytes: Promise<Uint8Array> = createPDFGeneric();
        console.log("Rendering PDF ... --> 2");

        promisePdfBytes.then((pb: Uint8Array) => {
            console.log("Rendering PDF ... --> 3 (" + ((pb !== undefined && pb.length > 0) ? pb.length : "0") + " bytes)");

            //
            console.log("Rendering PDF ... --> 4");
            //if(el.data !== undefined && el.data.length > 0) {
              listInputJSXElement.push(
                <div key={elementcounter++} style={{border: "1px orange solid", padding: "10px"}}>
                  <br/>
                  <br/>
                  <Document
                    onLoadError = {(error) => console.log('Error while loading document! ' + error.message)}
                    onLoadSuccess = {(pdf) => console.log('Loaded a file with ' + pdf.numPages + ' pages!')}
                    onSourceSuccess = {() => console.log('Document source retrieved!')}
                    file={{
                      data: pb
                      //data: el.data
                    }}
                  >
                    <PdfPage pageNumber={1} />
                  </Document>
                </div>
              )

              console.log("Rendering PDF ... --> 5");
            //}
          }
        )

        console.log("Rendering PDF ... --> 6");
      }
      break;
      */

      case(InputType.Multiple):
      break;

      default:
      break;
    }

    return(listInputJSXElement);
  });

  /*
  // ----
  if(pageToDisplay.showOverview) {
    listInputJSXElement.push(
      <GenericFlowOverview pagename={props.pagename}></GenericFlowOverview>
    )
  }
  */


  function PreviousButton(/*props: GenericPageComponentProps*/) {
    return (
      <Button variant="outlined" color="primary" style={{"minWidth":"100px", "width": "150px", color: "white", float: "left"}} onClick={handleSubmitBack}><ArrowBackIosIcon/>&nbsp;{t("SelectPrevious")}</Button>
    );
  }

  function NextButton(/*props: GenericPageComponentProps*/) {
    if(props.pagename !== getNextPageKey(pageToDisplay))
      return (
        <Button variant="outlined" color="primary" style={{"minWidth":"100px", "width": "150px", color: "white", float: "right"}} onClick={handleSubmit}>{t("SelectNext")}&nbsp;<ArrowForwardIosIcon/></Button> 
      );
    else
      return null;
  }

  function HomeButton(/*props: GenericPageComponentProps*/) {
    return (
      <Button variant="outlined" color="primary" style={{"minWidth":"50px", "width": "50px", color: "white", position: "absolute", left:"57%"}} onClick={handleSubmitHome}><HomeIcon/></Button> 
    );
  }

  // ----
  return (
    <div style={{ margin: "5px" }}>
        <h1>{pageToDisplay.label}</h1>
        <div style={{overflow: "auto", height:"700px"}}>
          {listInputJSXElement}
        </div>
        <div>
          <PreviousButton></PreviousButton>
          <HomeButton></HomeButton>
          <NextButton></NextButton> 
        </div>
        <br/>
        {/*
        <div>
          <UploadFilesDragAndDrop/>
        </div>
        */}
        {/*
        <textarea style={{margin: '0px', width: '1050px', height: '324px'}} value={jsonstring}></textarea>
        <br/>
        */}

        <Snackbar
          anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
          }}
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          >
          <Alert severity="error">{messageSnackbar}</Alert>
        </Snackbar>

    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(GenericPageComponent);
